import { useQuery } from "@tanstack/react-query";
import Table from "../../ChildComponents/Table";
import { MdEditDocument } from "react-icons/md";

import { useGetVideo } from "../../store/api/videoApi";

function RoleList({ onEdit }) {
  const getVideo = useGetVideo();
  const {
    data: videoData,
    isLoading: isTopicLoading,
    error: topicError,
  } = useQuery({ queryKey: ["video"], queryFn: getVideo });

  const data = videoData?.allVideos
    ?.map((e, index) => ({
      index: index + 1,
      title: e?.title,
      actionButton: (
        <>
          <button onClick={() => onEdit(e)} className="btn text-success mx-2">
            <MdEditDocument />
          </button>
        </>
      ),
    }))
    .reverse();

  const columns = [
    {
      header: "SL#",
      accessor: "index",
    },
    {
      header: "Title",
      accessor: "title",
    },
    {
      header: "Actions",
      accessor: "actionButton",
    },
  ];
  return (
    <div>
      <Table columns={columns} data={data} isLoading={isTopicLoading} />
    </div>
  );
}

export default RoleList;
